import React from "react";
import { Card, Chip } from "@mantine/core";
import { ReactComponent as CheckIcon } from "@/assets/icons/check.svg";
import { ReactComponent as MinusIcon } from "@/assets/icons/minus.svg";
import { findActiveSubscription } from "@/helpers/issuesAndSubscriptions";
import { UserWithSubscriptions } from "@/api/types";
import dayjs from "dayjs";

interface UserMobileCardProps {
  user: UserWithSubscriptions;
  onClick: (id: number) => void;
}

const UserMobileCard: React.FC<UserMobileCardProps> = ({ user, onClick }) => {
  return (
    <Card
      shadow="sm"
      padding="lg"
      radius="md"
      className="mobile-user-card"
      onClick={() => onClick(user.id)}
    >
      <div className="font-bold text-lg">
        {user.firstName} {user.lastName}
      </div>
      <div className="flex text-sm gap-2">
        <span className="font-medium">Email:</span>
        <span> {user.email}</span>
      </div>
      <div className="flex text-sm gap-2 items-center">
        <span className="font-medium">Godišnja pretplata:</span>
        <Chip
          checked={true}
          color={
            !!findActiveSubscription(user.userSubscriptions)
              ? "#2c973f"
              : "#515151"
          }
          icon={
            !!findActiveSubscription(user.userSubscriptions) ? (
              <CheckIcon />
            ) : (
              <MinusIcon />
            )
          }
          variant="light"
          className="inline !cursor-default font-bold py-1"
        >
          {!!findActiveSubscription(user.userSubscriptions)
            ? "Aktivna"
            : "Neaktivna"}
        </Chip>
      </div>
      <div className="flex text-sm gap-2">
        <span className="font-medium">Datum aktivacije:</span>
        <span>
          {(!!findActiveSubscription(user.userSubscriptions) &&
            dayjs(
              findActiveSubscription(user.userSubscriptions)?.startDate
            ).format("DD.MM.YYYY.")) ||
            "-"}
        </span>
      </div>
      <div className="flex text-sm gap-2">
        <span className="font-medium">Datum isteka:</span>
        <span>
          {(!!findActiveSubscription(user.userSubscriptions) &&
            dayjs(
              findActiveSubscription(user.userSubscriptions)?.endDate
            ).format("DD.MM.YYYY.")) ||
            "-"}
        </span>
      </div>
    </Card>
  );
};

export default UserMobileCard;
